import { AgeCategoryCount, AgeCategoryType } from '../FilterBarTypes'

type Props = {
  ageCategoryCounts: AgeCategoryCount
  ageCategories?: AgeCategoryType[]
}

export const ageCategoryRules = ({
  ageCategoryCounts,
  ageCategories,
}: Props): string => {
  if (ageCategories?.length) {
    ageCategories?.map((a) => {
      if (a.minVal) {
        const ageCategory = ageCategoryCounts[`guests-${a.id}`]

        if (!ageCategory) {
          ageCategoryCounts[`guests-${a.id}`] = a.minVal
        }
      }
    })
  }

  return Object.entries(ageCategoryCounts).length
    ? JSON.stringify(ageCategoryCounts)
    : ''
}
